<script>
  import Vue from 'vue';

  // Import component
  import Loading from 'vue-loading-overlay';
  
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';
  // Init plugin
  Vue.use(Loading);

  export default{
      loader: null,
      opened : false,
      showLoading(context){
        if(!this.opened){
          this.opened = true;
          this.loader = context.$loading.show({
              // // Optional parameters
              // container: context.fullPage ? null : context.$refs.formContainer,
              // canCancel: true,
              // onCancel: context.onCancel,
            });
        }
      },
      hideLoading(context){
        if(this.opened){
          this.opened = false;
          this.loader.hide();
        }
      }
  }
</script>